export default "__VITE_ASSET__CybW$A8u__"